import {useTickerSearchIndex} from "../../../modules/Search/useTickerSearchIndex";
import TickerChip from "../../../components/TickerChip";
import {stringMixin} from "../../../utils/strings";
import {Card, Col, Row, Space, Table, Typography} from "antd";
import ViewableResponse from "../../../modules/Inference/components/ViewableResponse";
import React from "react";



const PortfolioBlock = ({ portfolios = [] }) => {
    // Ensure the portfolios array is not empty and each portfolio has holdings
    const uniqueTickers = [...new Set(portfolios
        .filter(portfolio => portfolio && Array.isArray(portfolio.holdings)) // Filter out any invalid portfolios or ones without holdings
        .flatMap(portfolio =>
            portfolio.holdings.map(holding => holding.symbol.toLowerCase())
        ))];

    const { tickers } = useTickerSearchIndex(uniqueTickers);

    const columns = [
        {
            title: 'Ticker',
            dataIndex: 'symbol',
            key: 'symbol',
            render: (symbol) => {
                const ticker = tickers.find(x => x.symbol === symbol.toLowerCase());
                return ticker ? <TickerChip ticker={ticker} /> : symbol;
            }
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            render: (weight) => stringMixin.pct(weight)
        }
    ];

    return (
        <div className={'p-6'} style={{maxHeight: '70vh', overflowY: 'scroll'}}>
            {portfolios
                .filter(portfolio => portfolio && Array.isArray(portfolio.holdings)) // Safeguard to ensure valid portfolios
                .map((portfolio, index) => (
                    <div key={index} style={{ marginBottom: '20px' }}>
                        <h3>{portfolio.title}</h3>
                        <Table
                            columns={columns}
                            dataSource={portfolio.holdings}
                            rowKey="symbol"
                            pagination={false}
                        />
                    </div>
                ))}
        </div>
    );
};

const PrincipalComponentGroups = ({components})=>{

    const PcGrid = ({items})=>{
        return (
            <Row gutter={16}>
                {items.map((item, index)=>(
                    <Col span={12} style={{border: '1px solid #ddd'}} className={'p-4'}>
                        <Space direction={'vertical'} className={'px-4'}>
                            <Typography.Text strong>
                                {item.key} - {stringMixin.pct(item.weight)}
                            </Typography.Text>
                            <Typography.Text>
                                {item.name}
                            </Typography.Text>
                        </Space>
                    </Col>
                ))}
            </Row>
        )
    }

    return (
        <Row gutter={[16, 16]}>
            {components.map((component, index)=>(
                <Col span={24}>
                    <Card bordered={false}
                        title={<Typography.Title level={4} style={{fontWeight: '500'}}>{component.title}</Typography.Title>}
                          extra={<span style={{fontSize: '24px'}}>{component.icon}</span>}
                          // extra={renderIcon(component?.icon?.split('Icon')[0])}
                    >
                        <PcGrid items={component.components} />
                    </Card>
                </Col>
            ))}
        </Row>
    )
}


const PcaInference = ({parsedResponse})=>{
    const { raw } = parsedResponse;
    const portfolios = parsedResponse?.portfolio;
    const summary = parsedResponse?.summary;
    const components = parsedResponse?.components;
    return (
        <Row align={'top'} justify={'center'}>
            <Col span={12}>
                <ViewableResponse markdownText={summary} title={'Summary'} />
                {components && (
                    <PrincipalComponentGroups components={components} />
                )}
            </Col>
            <Col span={12}>
                {Array.isArray(portfolios) && portfolios.length>0 && (
                    <PortfolioBlock portfolios={portfolios} />

                )}
            </Col>

        </Row>
    )

}

export default PcaInference;